import React from "react";

type props = {
    embedId: string
}

const YoutubeEmbed : React.FC<props> = ({ embedId }) => (
  <div className="video-responsive">
    <iframe
      width="360px"
      height="200px"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

export default YoutubeEmbed;